{
  "characters": "tegn"
}
